import Prismic from 'prismic-javascript';
import { HTTP_SERVER_GATEWAY_TIMEOUT } from '../../helpers/http';
import { toDocPrismic, toRegionPrismic } from '../../schema/prismic/mapping';
import { DocumentType } from '../../types/document';
import getClient from './prismic-api';

const callClient = (fn) =>
  getClient()
    .then(fn)
    .catch(() => Promise.reject({ status: HTTP_SERVER_GATEWAY_TIMEOUT }));

/**
 * Get a paginated list of documents by query from prismic
 *
 * @param {string|string[]} query
 * @param {object} opts of the query
 * @return {object} the paginated list of documents
 */
export const query = (q, opts = {}) =>
  callClient((client) => client.query(q, opts));

/**
 * Get a paginated list of documents by ids from prismic
 *
 * @param {string[]} ids of document
 * @param {object} opts of the query
 * @return {object} the paginated list of documents
 */
export const getByIDs = (ids, opts = {}) =>
  callClient((client) => client.getByIDs(ids, opts));

/**
 * Get a document by query from prismic
 *
 * @param {string|string[]} query
 * @param {object} opts of the query
 * @return {object} the document
 */
export const queryFirst = (q, opts = {}) =>
  callClient((client) => client.queryFirst(q, opts));

/**
 * Get a document by id from prismic
 *
 * @param {string} id of document
 * @param {object} opts of the query
 * @return {object} the document
 */
export const getByID = (id, opts = {}) =>
  callClient((client) => client.getByID(id, opts));

/**
 * Get a document by uid from prismic
 *
 * @param {string} type of document
 * @param {string} uid of document
 * @param {object} opts of the query
 * @return {object} the document
 */
export const getByUID = (type, uid, opts = {}) =>
  callClient((client) => {
    if (type === DocumentType.HOME) {
      return client.queryFirst(
        [
          Prismic.Predicates.at(
            'document.type',
            toDocPrismic(DocumentType.HOME)
          ),
          Prismic.Predicates.at(
            'my.home_page.main_region',
            toRegionPrismic(uid)
          ),
        ],
        opts
      );
    }
    return client.getByUID(toDocPrismic(type), uid, opts);
  });

/**
 * Get a single type document from prismic
 *
 * @param {string} type of document
 * @param {object} opts of the query
 * @return {object} the document
 */
export const getSingle = (type, opts = {}) =>
  callClient((client) => client.getSingle(toDocPrismic(type), opts));

export default getClient;
